import { render, staticRenderFns } from "./VatWrapper.vue?vue&type=template&id=63b8d914&"
import script from "./VatWrapper.vue?vue&type=script&lang=js&"
export * from "./VatWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports